import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SubSink } from "subsink";
import { StringHelper } from "../../../../../../utilities/contracts/string-helper";
import { ChaseDetailStateService } from "../../../../member/chase-detail/chase-detail-state.service";
import { ChaseDetailService } from "../../../../member/chase-detail/chase-detail.service";
import { ChaseDetailForAuditItem } from "../../../chase-detail-for-audit-item.model";
import { AuditQueryHeaderService } from "../../audit-query-shared/audit-query-header/audit-query-header.service";
import { AuditQueryChartRiskService } from "./audit-query-chart-risk.service";

@Component({
  selector: "app-audit-query-chart-risk",
  templateUrl: "./audit-query-chart-risk.component.html",
  styleUrls: ["./audit-query-chart-risk.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditQueryChartRiskComponent implements OnInit, OnDestroy {
  private sink = new SubSink();
  private unsubscribe = new Subject();
  chaseDetails: ChaseDetailForAuditItem;
  isVisible = false;

  constructor(
    private readonly auditQueryChartRiskService: AuditQueryChartRiskService,
    private chaseDetailStateService: ChaseDetailStateService,
    private chaseDetailService: ChaseDetailService,
    private auditQueryHeaderService: AuditQueryHeaderService,
    private readonly changeDetector: ChangeDetectorRef
  ) { }

  get iframeSrc(): string {
    return `app/chases/${this.chaseDetails?.chaseId}?auditPackageItemId=${this.chaseDetails?.auditPackageItemId}&pageNumber=${this.diagnosisPageNumber}`;
  }

  get diagnosisPageNumber(): number {
    return this.chaseDetails?.diagnosisPageNumber ? this.chaseDetails.diagnosisPageNumber : 1;
  }

  get classes(): string {
    return "iframe_react_container--coding_screen";
  }

  ngOnInit() {
    this.auditQueryChartRiskService.setChaseDetails(null);

    this.sink.add(
      this.auditQueryHeaderService.selectedTab
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(data => {
          if (StringHelper.isAvailable(data) && data === "auditquery") {
            this.isVisible = false;
            this.changeDetector.markForCheck();
          }
        }),

      this.auditQueryChartRiskService.auditChaseDetails
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(data => {
          this.chaseDetails = data;
          if (data != null) {
            this.getChaseDetailState();
            this.isVisible = true;
          }
          this.changeDetector.markForCheck();
        })
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private getChaseDetailState(): void {
    this.chaseDetailService.getChaseDetail(this.chaseDetails.chaseId)
      .subscribe(chaseDetail => {
        this.chaseDetailStateService.setData({
          ...chaseDetail,
        });
      });
  }

}
